import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input, message } from 'antd';
import AccentButton from '../components/AccentButton/AccentButton';
import AccentButtonDark from '../components/AccentButtonDark/AccentButtonDark';
import { useAuth } from '../contexts/AuthContext';
import './SignIn.css';

const SignIn: React.FC = () => {
    const navigate = useNavigate();
    const { signIn } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSignIn = async () => {
        if (!email || !password) {
            message.error('Please enter both email and password');
            return;
        }

        setLoading(true);
        try {
            await signIn(email, password);
            message.success('Successfully signed in!');
            navigate('/home');
        } catch (error: any) {
            message.error(error.message || 'Failed to sign in');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="signin-page">
            <div className="signin-content">
                <h1 className="signin-title">Sign In</h1>

                {/* Spacer to align with signup page */}
                <div className="signin-spacer" />

                {/* Form Fields */}
                <div className="signin-form">
                    <div className="signin-field">
                        <label className="signin-label">Email</label>
                        <Input
                            placeholder="Email Address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="signin-field">
                        <label className="signin-label">Password</label>
                        <Input.Password
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <AccentButton
                        size="large"
                        block
                        shape="round"
                        onClick={handleSignIn}
                        loading={loading}
                    >
                        Sign In
                    </AccentButton>
                </div>

                {/* Don't have account */}
                <div className="signin-divider signin-footer-divider">
                    <span className="signin-divider-line" />
                    <span className="signin-divider-text">don't have an account?</span>
                    <span className="signin-divider-line" />
                </div>

                <AccentButtonDark
                    block
                    size="large"
                    shape="round"
                    onClick={() => navigate('/signup')}
                >
                    Sign Up
                </AccentButtonDark>
            </div>
        </div>
    );
};

export default SignIn;
